<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" @click="showDialog"
      >创建邮寄地址
      </Button>
      <vxe-button
          icon="vxe-icon--refresh"
          @click="refresh"
          :style="
          !isHavePermission('bankAccount:createPlatformCompany:add')
            ? ''
            : 'margin-left: 20px'
        "
      >刷新
      </vxe-button>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          auto-resize
          :data="tableData"
          max-height="540"
          :loading="loading"
      >
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="linkMan" title="联系人"></vxe-table-column>
        <vxe-table-column field="linkPhone" title="联系电话"></vxe-table-column>
        <vxe-table-column field="content" title="邮寄地址">
          <template slot-scope="{ row }">
            <span>
              {{ row.address + row.content }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="操作">
          <template slot-scope="{ row }">
            <span
                style="color: #2d8cf0; cursor: pointer; margin-right: 10px"
                @click="openUpdateView(row)"
            >编辑</span
            >
            <span style="color: red; cursor: pointer;margin-right: 10px" @click="commitDelete(row)"
            >删除</span
            >
            <span v-if="row.isDefault === 1">默认</span>
            <span v-else style="color: #2d8cf0; cursor: pointer;" @click="updateDefaultUserAddress(row)">设为默认</span>
            
          </template>
        </vxe-table-column>
      </vxe-table>
      <!-- <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>-->
    </div>
    <!-- 创建邮寄地址 -->
    <vxe-modal
        v-model="createAccountModal"
        width="600"
        height="400"
        footer-hide
        transfer
        destroy-on-close
    >
      <p slot="header" class="box-tit-211130">
        <span>{{ title }}</span>
      </p>
      <vxe-form
          ref="accountFrom"
          title-align="right"
          title-width="110"
          :data="addressData"
          :rules="formRules2"
          style="margin-top: 20px; padding-right: 50px"
          @submit="submitAccount"
      >
        <vxe-form-item title="联系人" field="linkMan" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="addressData.linkMan"
                placeholder="请输入联系人"
                @input="$refs.accountFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="联系电话" field="linkPhone" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="addressData.linkPhone"
                placeholder="请输入联系电话"
                @input="$refs.accountFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="省市区" field="pro" span="24">
          <template>
            <Cascader
                v-model="addressData.pro"
                :data="home_port"
                trigger="hover"
                transfer
            ></Cascader>
          </template>
        </vxe-form-item>
        <vxe-form-item title="详细地址" field="content" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="addressData.content"
                placeholder="请输入详细地址"
                @input="$refs.accountFrom.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item align="right" span="24" style="margin-top: 20px">
          <vxe-button
              status="primary"
              style="width: 140px; border-radius: 0px"
              @click="cancelSubmit"
          >取消
          </vxe-button
          >
          <vxe-button
              type="submit"
              status="primary"
              style="width: 140px; border-radius: 0px"
          >保存
          </vxe-button
          >
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  name: "BankAccount",
  components: {},
  props: {
    userId: Number,
    isXcw: {
      type: Boolean,
      default: false
    }
  },
  mixins: [getAuthOrization],
  data() {
    return {
      title: "",
      createAccountModal: false,
      addressData: {},
      commitType: 1,
      visible: false,
      updateVisible: false,
      loading: false,
      tableData: [],
      page: {
        currentPage: 1,
        pageSize: 100,
        totalResult: 100,
      },
      formRules2: {
        linkMan: [{required: true, message: "请输入联系人"}],
        linkPhone: [{required: true, message: "请输入联系电话"}],
        pro: [{required: true, message: "请选择省市区"}],
        content: [{required: true, message: "请输入详细地址"}],
      },
      home_port: []
    };
  },
  mounted() {
    this.getHomePort();
  },
  methods: {
    async getHomePort() {
      showLoading()
      let res = await $api.xcwDict.request('queryProCityAreaList');
      hideLoading();
      if (res.code === 1) {
        let province = [];
        res.data.map(i => {
          if (i.cityCodeP === '0') {
            province.push({
              label: i.cityText,
              value: i.cityCode,
              children: []
            })
          }
        })
        province.map(i => {
          res.data.map(j => {
            if (i.value === j.cityCodeP) {
              i.children.push({
                label: j.cityText,
                value: j.cityCode,
                children: []
              })
            }
          })
        })
        province.map(i => {
          i.children.map(j => {
            res.data.map(k => {
              if (j.value === k.cityCodeP) {
                j.children.push({
                  label: k.cityText,
                  value: k.cityCode,
                })
              }
            })
          })
        })

        this.home_port = province;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    refresh() {
      this.queryUserAddressList(this.userId);
    },
    afterSave() {
      this.visible = false;
      this.queryUserAddressList(this.userId);
    },
    async queryUserAddressList(id) {
      this.loading = true;
      // let data = this.listQuery;
      this.userId = id;
      let obj = this.isXcw ? {
        userIdClient: id
      } : {
        userId: id
      }
      let res = await $api.baseUserSignAddress.request(this.isXcw ? 'queryUserAddressListByClientId' : "queryUserAddressList", obj);
      if (res.status === 1) {
        res.data.map(i => {
          if (i.pro) {
            i.pro = i.pro.split(',');
            let address = '';
            this.home_port.map(x => {
              if (x.value === i.pro[0]) {
                address = address + x.label;
                x.children.map(y => {
                  if (y.value === i.pro[1]) {
                    address = address + y.label;
                    y.children.map(z => {
                      if (z.value === i.pro[2]) {
                        address = address + z.label;
                      }
                    })
                  }
                })
              }
            })
            i.address = address;
          }
        })
        this.tableData = res.data;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        this.loading = false;
      }
    },
    async updateDefaultUserAddress(row) {
      let data = {
        id: row.id
      }
      let res = await $api.baseUserSignAddress.request('updateDefaultUserAddress',data)
      if(res.status ===1) {
        this.$Message.success("设置成功");
        this.queryUserAddressList(this.userId);
      }
    },
    commitDelete(row) {
      if(row.isDefault === 1) {
        //请重新设置成非默认地址
        this.$Message.error("请重新设置成非默认地址")
        return
      }
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.deleteAccount(row);
        }
      });
    },
    async deleteAccount(row) {
      var obj = {id: row.id};
      let res = await $api.baseUserSignAddress.request("deleteUserAddress", obj);
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.queryUserAddressList(this.userId);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.visible = false;
    },
    closeCreate() {
      this.visible = false;
      this.$refs.accountModal.close();
    },
    changePage(e) {
    },
    showDialog() {
      this.addressData = {};
      this.title = "新增邮寄地址";
      this.commitType = 1;
      if(this.isXcw){
        this.addressData.userIdClient = this.userId;
      }else{
        this.addressData.userIdSign = this.userId;
      }
      this.createAccountModal = true;
    },
    openUpdateView(row) {
      this.title = "修改邮寄地址";
      let obj = JSON.parse(JSON.stringify(row));
      this.addressData = obj;
      this.addressData.id = row.id;
      if(this.isXcw){
        this.addressData.userIdClient = this.userId;
      }else{
        this.addressData.userIdSign = this.userId;
      }
      this.commitType = 2;
      this.createAccountModal = true;
    },
    cancelSubmit() {
      this.createAccountModal = false;
    },
    async submitAccount() {
      let self = this;
      let url = "createUserAddress";
      if (this.commitType == 1) {
        url = "createUserAddress";
      } else if (this.commitType == 2) {
        url = "updateUserAddress";
      }
      let obj = Object.assign({}, this.addressData);
      obj.pro = obj.pro.toString();
      let res = await $api.baseUserSignAddress.request(url, obj).catch(function (er) {
        console.log(er.response.data.message);
        self.$XModal.alert({
          message: er.response.data.message
              ? er.response.data.message
              : "接口异常",
          status: "error",
        });
        return;
      });
      if (res.status == 1) {
        this.$Message["success"]({
          background: true,
          content: "更新成功",
        });
        this.createAccountModal = false;
        this.queryUserAddressList(this.userId);
      } else {
        this.$emit("closeEdit", false);
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
  },
};
</script>

<style>
@import "../../../src/assets/icon/icon-filter/iconfont.css";
@import "../../../src/assets/icon/icon-more/iconfont.css";

.button-gengduo {
  border: none;
}

.button-gengduo:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.page-con-header {
  margin-bottom: 10px;
  position: relative;
}
</style>